import React from 'react'
import { Link } from 'react-router-dom'

const EventBoxCel = ({item}) => {
  return (
    <>
    <div className="post-card">
        <div className="post-card__image" style={{maxHeight:'190px', minHeight:'190px', overflow:'hidden'}}><Link to={item?.type === 1 ? `/events/${item?.slug}`:`/press-release/${item?.slug}`}>
            <img alt="" src={item?.image} /></Link></div>
        <div className="post-card__content bg-white">
            <div className="post-card__category"><span className='txtlgeay'>{item?.date}</span></div>
            <div className="post-card__title">
                <h2><Link to={item?.type === 1 ? `/events/${item?.slug}`:`/press-release/${item?.slug}`}  className='txtdgray'>{item?.title}</Link></h2>
            </div>
            <div className="post-card__date f12 mt-2"><Link to={item?.type === 1 ? `/events/${item?.slug}`:`/press-release/${item?.slug}`} className='txtred'>READ MORE</Link></div>
        </div>
    </div>
    </>
  )
}

export default EventBoxCel